import React from 'react';
import { getTrainingIconAlt, getTrainingIconSrc } from '../utils/trainingIcons';

/** Single training row icon (completed trainings use certified styling). */
export default function TrainingLineIcon({ training, certified = true }) {
  const src = getTrainingIconSrc(training);
  if (!src) return null;

  return (
    <img
      src={src}
      alt={getTrainingIconAlt(training)}
      className={`basic-icon ${certified ? 'certified' : 'required'}`}
      title={getTrainingIconAlt(training)}
    />
  );
}
